const reservationsES = {
  'reservations.reservations': '[ES] Reservations',
  'reservations.settings': '[ES] Settings',
  'reservations.reservations-settings': '[ES] Reservations Settings',
  'reservations.online-reservations-waitlist-settings':
    '[ES] Online Reservations & Waitlist Settings',
  'reservations.enable-in-house-reservations': '[ES] Enable In-House Reservations and Waitlist',
  'reservations.always-enabled': '[ES] This is always enabled for all shifts.',
  'reservations.online-reservations-waitlist': '[ES] Online Reservations Waitlist',
  'reservations.online-reservations-waitlist-description':
    '[ES] Allow guests to add themselves to a Reservation Waitlist if their preferred booking time is unavailable. You must contact these guests to inform them if their booking request can be accepted.',
  'reservations.discover-online': '[ES] Discover Online',
  'reservations.discover-online-description':
    '[ES] Guests can search for your restaurant on TouchBistro Dine and book a table through Reserve with Google.',
  'reservations.enable-walk-in-waitlist': '[ES] Enable Online Walk-In Waitlist',
  'reservations.enable-walk-in-waitlist-description':
    '[ES] Reserve with Google allows guests to join your waitlist online and be notified of their place in line. This applies to all shifts.',
  'reservations.minimum': '[ES] Minimum',
  'reservations.maximum': '[ES] Maximum',
  'reservations.min-party-size': '[ES] Minimum Party Size',
  'reservations.max-party-size': '[ES] Maximum Party Size',
  'reservations.save': '[ES] Save',
  'reservations.tb-dine-page': '[ES] TB Dine Page',
  'reservations.customize-tb-dine-page': '[ES] Customize your TB Dine Page',
  'reservations.fill-out-restaurant-profile':
    '[ES] Fill out your restaurant profile with information that guests will use to....',
  'reservations.view-restaurant-profile': '[ES] View Restaurant Profile',
  'reservations.view-tb-dine-page': '[ES] View TB Dine Page',
  'reservations.settings-updated-success': '[ES] Your settings have benn successfully updated.',
  'reservations.availability-planning': '[ES] Availability Planning',
  'reservations.overrides': '[ES] Overrides',
  'reservations.overrides-name': '[ES] Override Name',
  'reservations.overrides-description':
    '[ES] Create Shifts Overrides when you need to change your schedule settings on days that are not part of your typical schedule.',
  'reservations.override-create-new-button': '[ES] Create New Override',
  'reservations.service-period': '[ES] Service Period',
  'reservations.7_days_recurring_schedule': '[ES] 7 Days Recurring Schedule',
  'reservations.7_days_recurring_schedule.info':
    '[ES] Preview and schedule recurring Shifts for each Day of the Week and Service Period (SP).',
  'reservations.sp_1': '[ES] SP 1',
  'reservations.sp_2': '[ES] SP 2',
  'reservations.monday': '[ES] monday',
  'reservations.tuesday': '[ES] tuesday',
  'reservations.wednesday': '[ES] wednesday',
  'reservations.thursday': '[ES] thursday',
  'reservations.friday': '[ES] friday',
  'reservations.saturday': '[ES] saturday',
  'reservations.sunday': '[ES] sunday',
  'reservations.create_new_shift': '[ES] Create New Shift',
  'reservations.edit_shift': '[ES] Edit Shift',
  'reservations.shifts': '[ES] Shifts',
  'reservations.shifts-management': '[ES] Shifts Management',
  'reservations.shifts-management-description':
    '[ES] Create and manage your recurring or one-time Shifts. Set Shifts time, Table Availability, Pacing and Turn Times and schedule each Shift on the 7 Day Recurring Schedule table above.',
  'reservations.create-new-shift': '[ES] Create New Shift',
  'reservations.shift-name': '[ES] SHIFT NAME',
  'reservations.shift-start-and-end-time': '[ES] START & END TIME',
  'reservations.no-existing-shifts': '[ES] You currently have no Shifts to be displayed.',
  'reservations.closures': '[ES] Closures',
  'reservations.closures-description':
    '[ES] Block booking for specific upcoming dates or date ranges. Closures will turn off all Online and In House availability and will cancel any pre-booked reservations for those dates.',
  'reservations.closures-create-button': '[ES] Create New Closure',
  'reservations.closures-name': '[ES] Closure Name',
  'reservations.closures-sp': '[ES] Service Period',
  'reservations.closures-type': '[ES] Closure Type',
  'reservations.empty-setting-message': '[ES] You currently have no {{type}} to be displayed.',
  'reservations.none': '[ES] None',
  'reservations.step_of_total': '[ES] STEP {{current}}/{{total}}',
  'reservations.shift_details': '[ES] Shift Details',
  'reservations.shift_details.description':
    '[ES] Specify the shift name and when you would like the shift to occur.',
  'reservations.shift_name': '[ES] Shift Name',
  'reservations.max_n_chars': '[ES] Maximum {{limit}} characters',
  'reservations.first_seating': '[ES] First Seating',
  'reservations.last_seating': '[ES] Last Seating',
  'reservations.availability': '[ES] Availability',
  'reservations.availability.description':
    '[ES] Specify how the system will manage online reservations.',
  'reservations.restrict_reservations_to_waitlist':
    '[ES] Restrict Online Reservations to be Waitlist Only',
  'reservations.restrict_reservations_to_waitlist.description':
    '[ES] If enabled, guests will only be able to add themselves to waitlist using TB Dine and the booking widget on your website for the days this shift is scheduled.',
  'reservation.note_bold': '[ES] Note:',
  'reservation.restrict_note_online_reservation_waitlist_link_text':
    '[ES] Online Reservation Waitlist',
  'reservation.restrict_note_description_test': '[ES] must be turned ON to use this setting.',
  'reservations.table_availability': '[ES] Table Availability',
  'reservations.table_availability.description':
    '[ES] Select the floor plans you want available during your shift. Click “Edit Table Availability” to manage the availabilities of tables and combinations within a floor plan.',
  'reservations.floor_plan_name': '[ES] Floor Plan Name',
  'reservations.max_capacity': '[ES] Max Capacity',
  'reservations.available_capacity': '[ES] Available Capacity',
  'reservations.min_party': '[ES] Min Party',
  'reservations.max_party': '[ES] Max Party',
  'reservations.online_and_in_house': '[ES] Online & In House',
  'reservations.in_house_only': '[ES] In House Only',
  'reservations.online_only': '[ES] Online Only',
  'reservations.walk_in_only': '[ES] Walk-in Only',
  'reservations.availability_empty_content':
    '[ES] There are no Floor Plans with Tables created for your Venue. To assign Tables that can be reserved for the Shift, you should have at least one Floor Plan created and Tables added to it.',
  'reservations.edit_table_availability': '[ES] Edit Table Availablity',
  'reservations.edit_table_availabilities': '[ES] Edit Table Availabilities',
  'reservations.go_to_floor_plan': '[ES] Go to Floor Plan',
  'reservations.pacing': '[ES] Pacing',
  'reservations.pacing.description':
    '[ES] Pacing allows you to control the maximum number of parties and guests that can book reservations every 15 minutes. Applies to Online & In House bookings for this shift.',
  'reservations.time': '[ES] Time',
  'reservations.max_number_parties': '[ES] Max Number of Parties',
  'reservations.max_number_guests': '[ES] Max Number of Guests',
  'reservations.same_pacing': 'Same pacing all shift for every 15 minute interval',
  'reservations.no_limit': '[ES] No Limit',
  'reservations.turn_times': '[ES] Turn Times',
  'reservations.turn_times.description':
    '[ES] Specify the expected turn times for each party size.',
  'reservations.party_size': '[ES] Party Size',
  'reservations.expected_time': '[ES] Expected Time (HH / MM)',
  'reservations.party_size.guests': '[ES] {{size}} Guests',
  'reservations.hours': '[ES] hour(s)',
  'reservations.min': '[ES] min',
  'reservations.item_created': '"[ES] {{item_name}}" has been successfully created.',
  'reservations.item_updated': '"[ES] {{item_name}}" has been successfully updated.',
  'reservations.duration': '[ES] Duration',
  'reservations.back_to_create_shift': '[ES] Back to Create New Shift',
  'reservations.select_floorplan_to_edit': '[ES] Select floor plan to edit',
  'reservations.table_and_combinations': '[ES] Table / Combinations',
  'reservations.table_priority': '[ES] Table Priority',
  'reservations.min_seats': '[ES] Min Seats',
  'reservations.max_seats': '[ES] Max Seats',
  'reservations.table_type': '[ES] Table Type',
  'reservations.adult_only': '[ES] Adult Only',
  'reservations.hidden_overlap_shifts_info':
    '[ES] Shifts that overlap with the timing of your other service period are not available.',
  'reservations.table_availability_confirmation_dialog.title':
    '[ES] Are you sure you want to leave this page without applying your changes?',
  'reservations.table_availability_confirmation_dialog.discard': '[ES] Discard Changes',
  'reservations.table_availability_confirmation_dialog.apply': '[ES] Apply Changes',
  'reservations.select_floor_plan': '[ES] Select Floor Plan',
  'reservations.no_floor_plan_selected': '[ES] You currently have no Floor Plan selected.',
  'reservations.create_new_closure': '[ES] Create New Closure',
  'reservations.edit_closure': '[ES] Edit Closure',
  'reservations.create_new_override': '[ES] Create New Override',
  'reservations.edit_override': '[ES] Edit Override',
  'reservations.back_to_availability_planning': '[ES] Back to Availability Planning',
  'reservations.closure_details': '[ES] Closure Details',
  'reservations.override_details': '[ES] Override Details',
  'reservations.override_shift_name': '[ES] Shift',
  'reservations.closure_name': '[ES] Closure Name',
  'reservations.override_reason': '[ES] Reason',
  'reservations.optional_field': '[ES] (Optional)',
  'reservations.closure_applies': '[ES] Applies',
  'reservations.closure_frequency.once': '[ES] Once',
  'reservations.closure_frequency.weekly': '[ES] Weekly',
  'reservations.closure_frequency.daily': '[ES] Daily',
  'reservations.when': '[ES] When',
  'reservations.select_dates': '[ES] Select Dates',
  'reservations.service_period': '[ES] Service Period',
  'reservations.closure_type': '[ES] Closure Type',
  'reservations.edit_multiple_selections': '[ES] Edit Multiple Selections',
  'reservations.edit_tables_with_quantity':
    '[ES] Editing {{number}} tables and table combinations.',
  'reservations.mixed': '[ES] Mixed',
  'reservation.shift': '[ES] shift',
  'reservations.closure': '[ES] closure',
  'reservations.override': '[ES] override',
  'reservations.confirmation_modal.simple.title':
    '[ES] Are you sure you want to delete this {{item_type}}?',
  'reservations.confirmation_modal.simple.title2': '[ES] Deleting {{item_type}} can not be undone.',
  'reservations.confirmation_modal.message':
    '[ES] Are you sure you want to delete this {{item_type}}: {{item_name}} ?',
  'reservations.confirmation_modal.title':
    '[ES] Are you sure you want to delete the "{{item_name}}" {{item_type}}?',
  'reservations.action_create.success': '[ES] Your {{item_type}} has been created.',
  'reservations.action_update.success': '[ES] Your {{item_type}} has been updated.',
  'reservations.action_delete.success': '[ES] Your {{item_type}} has been deleted.',
  'reservations.action_delete.failure': 'Could not delete {{item_type}}: {{item_name}}',
  'reservations.online_booking': '[ES] Online Booking',
  'reservations.general_settings': '[ES] General Settings',
  'reservations.website_widgets': '[ES] Website Widgets',
  'reservations.booking_widgets': '[ES] Booking Widgets',
  'reservations.reserve_with_google': '[ES] Reserve with Google',
  'reservations.available_through': '[ES] Available through',
  'reservations.channel.widgets': '[ES] Website Widgets',
  'reservations.channel.tb_dine': '[ES] TouchBistro Dine',
  'reservations.channel.booking': '[ES] Online Booking Page',
  'reservations.channel.rwg': '[ES] Reserve with Google',
  'reservations.online_booking_window': '[ES] Online Booking Window',
  'reservations.online_booking_window.description':
    '[ES] How far in advance will guests be able to reserve online?',
  'reservations.online_booking_page': '[ES] Online Booking Page',
  'reservations.online_booking_page_link': '[ES] Online Booking Page Link',
  'reservations.online_booking_page_description':
    '[ES] Link guests to your TouchBistro Reservations Online Booking Page so they can easily reserve a table or join your waitlist.',
  'reservations.online_booking_page_copy.part_1':
    '[ES] This page is created for you using information you provide. The information (such as hours of operation, address, contact information, and more) can be updated by visiting the ',
  'reservations.online_booking_page_copy.part_2': '[ES] area of your account.',
  'reservations.venue_info': '[ES] Venue Info',
  'reservations.tbdine_profile_page': '[ES] TouchBistro Dine Profile Page',
  'reservations.tbdine_profile_page_copy.part_1':
    '[ES] Your profile is created for you using information you provide. The information (such as hours of operation, address, contact information, and more) can be updated by visiting the ',
  'reservations.tbdine_profile_page_copy.part_2': '[ES] area of your account.',
  'reservations.diner_notes': '[ES] Diner Notes',
  'reservations.diner_notes.description':
    '[ES] Use diner notes to communicate important information to guests who reserve or join the waitlist online.',
  'reservations.diner_notes.en_message.placeholder': '[ES] Enter Message',
  'reservations.diner_notes.en_message.error': '[ES] Oops! The character limit is 4000.',
  'reservations.minors': '[ES] Minors',
  'reservations.minors.description':
    '[ES] Turn this on if you want guests to indicate there are minors in their party.',
  'reservations.venue.name': '[ES] Venue: {{venue_details}} (Total)',
  'reservations.closure.full': '[ES] Full',
  'reservations.closure.partial': '[ES] Partial',
  'reservations.frequency.every': '[ES] Every',
  'reservations.frequency.everyday': '[ES] Everyday from',
  'reservations.from': '[ES] from',
  'reservations.booking_window_unit.minute': '[ES] Minutes',
  'reservations.booking_window_unit.hour': '[ES] Hours',
  'reservations.booking_window_unit.day': '[ES] Days',
  'reservations.booking_window_unit.week': '[ES] Weeks',
  'reservations.booking_window_unit.year': '[ES] Years',
  'reservations.select_shift_placeholder': '[ES] Select Shift',
  'reservations.enter_override_reason_placeholder': '[ES] Enter an Override reason',
  'reservations.select_frequency_placeholder': '[ES] Select Frequency',
  'reservations.select_service_period_placeholder': '[ES] Select Service Period',
  'reservations.rwg.description.part_1':
    '[ES] TouchBistro and Google drive more bookings together by making it easy to book online using Google Search and Maps.',
  'reservations.rwg.online_walk_in_waitlist': '[ES] Online Walk-In Waitlist',
  'reservations.rwg.online_walk_in_wailist.description':
    "[ES] Allow guests to join the Reserve with Google walk-in waitlist before they arrive. They'll even be automatically notified of their place in line.",
  'reservations.rwg.note': '[ES] Note',
  'reservations.rwg.note.description':
    "[ES]  must be turned ON to use Reserve with Google's Walk-in Waitlist.",
  'reservations.integration': '[ES] Integration',
  'reservations.rwg': '[ES] Reserve with Google',
  'reservations.examples': '[ES] Examples',
  'reservations.reserve_table': '[ES] Reserve a Table',
  'reservations.join_waitlist': '[ES] Join Waitlist',
  'reservations.reserve_table_join_waitlist': '[ES] Reserve a Table & Join Waitlist',
  'reservations.on_search': '[ES] On Search',
  'reservations.on_maps': '[ES] On Maps',
  'reservations.on_booking_page': '[ES] Booking Page',
  'reservations.on_join_waitlist_page': '[ES] Join Waitlist Page',
  'reservations.widget_location': '[ES] Location',
  'reservations.widget_location_title_default': '[ES] Select Venues',
  'reservations.widget_location_title': '[ES] {{count}} {{venue}} Selected',
  'reservations.widget_language': '[ES] Widget Language',
  'reservations.widget_type': '[ES] Widget Type',
  'reservations.widget_style': '[ES] Widget Style',
  'reservations.widget_type.row': '[ES] Row',
  'reservations.widget_type.col': '[ES] Column',
  'reservations.widget_type.block': '[ES] Block',
  'reservations.widget_style.default': '[ES] Default',
  'reservations.widget_style.branded': '[ES] Branded',
  'reservations.booking_widget.descr_1':
    "Easily embed the online booking form directly on your restaurant's website using a booking widget.",
  'reservations.booking_widget.descr_2':
    "Choose the style (or styles) you prefer, then copy and paste the widget code below into your website's HTML code.",
  'reservations.note': '[ES] Note',
  'reservations.booking_widget.descr_3.1':
    '[ES] To customize the branding of your Booking Widgets, go to the ',
  'reservations.branding': '[ES] Branding',
  'reservations.booking_widget.descr_3.2': '[ES]  area of Venue Info.',
  'reservations.booking_widget_missing_location.descr_1':
    '[ES] Select at least 1 Location to generate a preview of your Booking Widget',
  'reservations.booking_widget_missing_location.descr_2':
    '[ES] Select at least 1 location to generate your Booking Widget Code',
  'reservations.heads_up': '[ES] Heads up',
  'reservations.heads_up.descr_1': '[ES] Your ',
  'reservations.heads_up.descr_2': '[ES]  needs to be set up before guests can book online.',
  'reservations.widget_branding_cta.descr_1':
    '[ES] Did you know you can apply your brand colors to Booking Widgets?',
  'reservations.widget_branding_cta.descr_2.1': '[ES] Visit the ',
  'reservations.widget_branding_cta.descr_2.2': '[ES]  area of Venue Info to set this up.',
  'reservations.here': '[ES] here',
  'reservations.widget_branding_block.descr_1': '[ES] Click ',
  'reservations.widget_branding_block.descr_2':
    '[ES]  to customize Widgets with your brand colors.',
  'reservations.booking_widget_code': '[ES] Booking Widget Code',
  'reservations.booking_iframes': '[ES] Booking Iframes',
  'reservations.booking_iframes.descr':
    "[ES] An iframe can be used to include the TouchBistro Dine booking website on your restaurant's website so diners can book a reservation without having to leave your website. To use an iframe copy and paste the iframe code below into your website's HTML code.",
  'reservations.booking_iframe_code': '[ES] Booking Iframe Code',
  'reservations.sp_cutoff_time': '[ES] SP1 / SP2 Cutoff Time',
  'reservations.communications': '[ES] Communications',
  // errors
  'reservations.error.max-party-size-limit': '[ES] Maximum party size is 10',
  'reservations.error.min-max-party-size':
    '[ES] Minimum Party size can not be more than Maximum Party Size',
  'reservations.error.max-min-party-size':
    '[ES] Maximum Party size can not be less than Minimum Party Size',
  'reservations.error.character_limit': '[ES] {{field}} must be up to {{limit}} characters long.',
  'reservations.error.shift_name_unique':
    '[ES] This Shift name is already in use. Please enter a unique Shift name.',
  'reservations.error.first_last_seating_same':
    '[ES] First and Last Seating time cannot be the same.',
  'reservations.error.scheduling_conflict_header':
    '[ES] Oops! These seating times overlap with another scheduled shift:',
  'reservations.error.scheduling_conflict_footer':
    '[ES] To continue, please update the seating times or remove this shift from the recurring schedule.',
  'reservations.error.override_conflict_header':
    '[ES] Oops! This overlaps with another scheduled shift/override:',
  'reservations.error.override_conflict_footer':
    '[ES] To continue, please make sure no other shifts/overrides exist on the selected date(s) and Service Period(s)',
  'reservations.error.shiftwide_pacing_invalid_combo':
    '[ES] Please enter a valid max parties/max guests combination.',
  'reservations.error.zero_turn_time': '[ES] Expected turn time cannot be less than 15 minutes.',
  'reservations.error.parties_exceed_guests':
    '[ES] Number of parties cannot exceed the number of guests.',
  'reservations.error.zero_parties_and_guests':
    '[ES] When the number of parties is 0, the number of guests has to be 0.',
  'reservations.error.zero_guest_and_parties':
    '[ES] When the number of guests is 0, the number of parties has to be 0',
  'reservations.error.guests_less_than_parties':
    '[ES] Number of guests cannot be less than number of parties.',
  'reservations.error.min_max': '[ES] Oops! Minimum should be less than Maximum.',
  'reservations.error.max_duration': '[ES] Oops! 1 year is the limit.',
  'reservations.error.empty_shift_override_selection':
    '[ES] Please select a Shift in order to create an Override.',
  'reservations.error.empty_frequency_closure_selection':
    '[ES] Please choose how often you want your Closure applied.',
  'reservations.error.empty_frequency_override_selection':
    '[ES] Please choose how often you want your Override applied.',
  'reservations.error.empty_period_override_selection':
    '[ES] Please choose the Service Period you want your Override applied.',
  'reservations.error.conflict_more': '[ES] + {{count}} more',
  'reservations.shifts_delete.tooltip.inuse': '[ES] (In use)',
  'reservations.communications_guest_facing.title': '[ES] Guest Facing Communications',
  'reservations.communications_staff_facing.title': '[ES] Staff Facing Communications',
  'reservations.communications.guest_facing.appliesToTitle': '[ES] Applies to:',
  'reservations.communications.guest_facing.attendanceConfirmationRequestDescription':
    '[ES] Send guests a confirmation request based on the settings below.',
  'reservations.communications.guest_facing.attendanceConfirmationRequestTitle':
    '[ES] Attendance Confirmation Request',
  'reservations.communications.guest_facing.autoMessageDescription':
    '[ES] Automatically send messages that confirm bookings and notify customers when their table is ready. To preview this and other messages that TouchBistro Reservations sends to your guests, click <1><2>here<2></1>.',
  'reservations.communications.guest_facing.chooseWhenMessageIsSent':
    '[ES] Choose when the message is sent',
  'reservations.communications.guest_facing.chooseWhichPartySizesReceiveConfirmation':
    '[ES] Choose which party sizes will receive a confirmation',
  'reservations.communications.guest_facing.partySizes.all': '[ES] All party sizes',
  'reservations.communications.guest_facing.partySizes.group':
    '[ES] Parties of {{partySize}} or more',
  'reservations.communications.guest_facing.requestTime.before': '[ES] {{hours}}h before',
  'reservations.communications.guest_facing.requestTime.hours': '[ES] {{hours}} hours',
  'reservations.communications.guest_facing.requestTime.never': '[ES] Never',
  'reservations.communications.guest_facing.sendConfirmationRequestNotificationTitle':
    '[ES] Send Confirmation Request Notification:',
  'reservations.communications.table_is_ready_sms_title': '[ES] ”Table is Ready” SMS',
  'reservations.communications.table_is_ready_sms_description':
    '[ES] Personalize the SMS guests receive when their table is ready. The default message below will be sent if not edited.',
  'reservations.communications.table_is_ready_sms_msg_default':
    '[ES] Your table is now ready at {VenueName}, please return to the host stand within 5 minutes, thank you!',
  'reservations.communications.table_is_ready_sms_msg_example':
    '[ES] Personalize your message with the variables below, they’ll auto-fill with guest details. Example: Your table for {PartySize} is now ready at {VenueName}.',
  'reservations.communications_token_name': {
    first_name: '[ES] First Name',
    last_name: '[ES] Last Name',
    venue_name: '[ES] Venue Name',
    party_size: '[ES] Party Size',
  },
  'reservations.communications_message_preview_title': '[ES] Preview',
  'reservations.communications_message_preview': {
    title: '[ES] Message',
    msg_time: '[ES] NOW',
    msg_footer_text: '[ES] Reply 1: Cancel',
  },
  'reservations.communications.reset_button': '[ES] Reset',
  'reservations.communications.restore_default': '[ES] Restore default SMS',
  'reservations.communications.guest_facing.templated_message_title': '[ES] Templated Messages',
  'reservations.communications.guest_facing.templated_message_description':
    '[ES] Templated messages make it easy to quickly respond to common questions or share important information with guests.',
  'reservations.communications.guest_facing.templated_message.delete_dialog_confirmation':
    '[ES] Delete Template',
  'reservations.communications.guest_facing.templated_message.delete_dialog_title':
    '[ES] Are you sure you want to delete the Templated Message title "{{title}}"',
  'reservations.communications.guest_facing.templated_message.delete_dialog_subtitle':
    '[ES] This action is irreversible',
  'reservations.communications.guest_facing.templated_message_delete_success':
    '[ES] "{{title}}" has been deleted.',
  'reservations.communications.guest_facing.create_templated_message_button':
    '[ES] Create New Template',
  'reservations.communications.guest_facing.template_table.row_1': '[ES] Message Title',
  'reservations.communications.guest_facing.template_table.row_2': '[ES] Message',
  'reservations.communications.guest_facing.empty_table_message':
    '[ES] There are no templated messages yet.',
  'communication_name_validation.required': '[ES] A message title is required.',
  'communication_name_validation.max_length':
    '[ES] The title exceeds the {{length}} character limit.',
  'communication_message_validation.max_length':
    '[ES] This message exceeds the {{length}} character limit.',
  'communication_message_validation.required': '[ES] A message template is required.',
  'communication_template.create_title': '[ES] Create New Templated Message',
  'communication_template.edit_title': '[ES] Edit Templated Message',
  'communication_template.back_to_guest_communications_settings_link':
    '[ES] Back to Guest Communications Settings',
  'communication_template.templated_message_details_title': '[ES] Templated Message Details',
  'communication_template.message_title': '[ES] Message Title',
  'communication_template.optional': '[ES] Optional',
  'communication_template.message_title_placeholder': '[ES] Enter the templated message title',
  'communication_template.message_title_description':
    '[ES] Message titles help hosts identify which message template to use. Titles are only visible to staff, not guests.',
  'communication_template.message_body_title': '[ES] Templated Message',
  'communication_template.message_body_description':
    '[ES] Personalize your message with the variables below, they’ll auto-fill with guest details. Example: Hi {FirstName}, your table for {PartySize} at {ReservationTime} is confirmed!',
  'communication_template.message_body_placeholder': '[ES] Write the message guests will receive.',
  'communication_template.save_success_message': '[ES] Templated message saved successfully.',
  'communication_template.save_error_message':
    '[ES] There was an error saving the templated message.',
  'reservations.communications.booking_notification.title':
    '[ES] Configure which staff receive notifications:',
  'reservations.communications.booking_notification.description':
    '[ES] We only show staff members with a valid email address.',
  'reservations.communications.custom_staff_notifications.title':
    '[ES] Configure custom recipients for notifications:',
  'reservations.communications.daily_summary_email.title': '[ES] Daily Summary Email',
  'reservations.communications.daily_summary_email.description':
    '[ES] Choose if and when staff members receive a daily summary email of upcoming reservations and waitlist guests.',
  'reservations.communications.receive_daily_email_options.morning_only': '[ES] Morning only',
  'reservations.communications.receive_daily_email_options.morning_late_afternoon':
    '[ES] Morning and late afternoon',
  'reservations.communications.online_booking_notification.title':
    '[ES] Online Booking Notification',
  'reservations.communications.online_booking_notification.description':
    '[ES] Get notified when a guest creates, modifies, or cancels their booking online.',
  'reservations.communications.when_online_reservation_created':
    '[ES] When a new online reservation is made',
  'reservations.communications.when_online_reservation_modified':
    '[ES] When a guest modifies their reservation online',
  'reservations.communications.when_online_reservation_cancelled':
    '[ES] When a guest cancels their reservation online',
  'reservations.communications.validation.at_least_one_receiver':
    '[ES] Please select at least one receiver.',
  'reservations.communications.validation.email_notification_required_with_custom_email':
    '[ES] Enable at least one email notification for custom email recipients.',
  'reservations.communications.validation.sms_notification_required_with_custom_sms':
    '[ES] Enable at least one SMS notification for custom phone recipients.',
  'reservations.communications.guest_facing.save_success_message':
    '[ES] Communication settings saved successfully.',
  'reservations.communications.staff_facing.save_success_message':
    '[ES] Notification settings saved successfully.',
  'reservations.communications.staff_facing.custom_email_fields': '[ES] Add Custom Email',
  'reservations.communications.staff_facing.custom_phone_fields': '[ES] Add Custom Phone',
  'reservations.communications.validation.custom_receiver_contact_required':
    '[ES] A contact is required.',
  'reservations.communications.validation.custom_receiver_label_required':
    '[ES] A name is required.',
  'reservations.communications.validation.custom_receiver_contact_email_invalid':
    '[ES] Please enter a valid email address.',
  'reservations.communications.validation.custom_receiver_contact_phone_invalid':
    '[ES] Please enter a valid phone number.',
  'reservations.communications.staff_facing.non_staff_label': '[ES] {{main_label}}',
}

export default reservationsES
